module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Bold.woff2?1217aaefdb5b537c20e131c4874ffc36";